import * as types from "./Constants"
const initialState = {
    Loading: false,
    errors: "",
    successMsg: "",
    otpVerified: false
}

const ReportOtpReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SEND_REPORT_OTP:
        case types.VERIFY_REPORT_OTP:
            return {
                ...state,
                Loading: true,
                errors: "",
                successMsg: "",
                otpVerified: false
            }
        case types.SEND_REPORT_OTP_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }
        case types.VERIFY_REPORT_OTP_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                Loading: false,
                successMsg: action.payload,
                otpVerified: true
            }
        case types.SEND_REPORT_OTP_SUCCESS:
        case types.VERIFY_REPORT_OTP_FAILED:
            return {
                ...state,
                Loading: false,
                errors: action.payload,
                otpVerified: false
            }
        case types.RESET_VERIFY_REPORT:
            return {
                ...state,
                otpVerified: false,
                successMsg: "",
                errors: ""
            }

        default:
            return state;
    }
}
export default ReportOtpReducer;